import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { lastValueFrom } from 'rxjs';
import { OAuthStorage } from 'angular-oauth2-oidc';

registerLocaleData(localeDe);
registerLocaleData(localeEn);

export function HttpLoaderFactory(http: HttpClient) {
    // Translation files live under src/assets, so `outputHashing` never
    // fingerprints them and their URL is otherwise identical across releases.
    // Key it on the build date so a new release can never be served a previous
    // release's cached translations (which surface as "Missing translation for
    // key: ..." once new code asks for a key the stale file lacks). Mirrors the
    // `?v=` busting already used for assets/config.json and assets/version.json.
    // `buildDate` comes from build.json (CI_COMMIT_TIMESTAMP via prebuild.js) --
    // unlike `version`, which reads package.json and is never bumped.
    return new TranslateHttpLoader(
        http,
        '/assets/i18n/',
        `.json?v=${encodeURIComponent(environment.buildDate)}`
    );
}

export function loadTranslations(translateService: TranslateService) {
    return () => lastValueFrom(translateService.use('de'));
}

export function storageFactory(): OAuthStorage {
    return localStorage;
}
